import React from 'react';
import { PassSC, Pass, ChangePasswords, FormDiv } from './EditEmailInfo.style';
import { Trans, useTranslation } from 'react-i18next';
import { Highlight } from 'components/vm-deployment/components';
import { edit_Email_Contact_Form } from 'constants/account-profile';
import { Grid } from '@mui/material';
import Input from 'components/input';
import { Formik, Form } from 'formik';
import { initialValues, validationSchema } from 'constants/account-profile';
import CustomButton from 'components/common/custom-button';
import 'components/input/input.css';
import { Heading } from 'components/user-management/Heading';
import { P } from 'components/reusable-css';
import { Label } from 'assets/css/common-styles';
import { mockEmailContact } from 'pages/mockup/constant';

const EditEmail = ({ width }) => {
  const { t } = useTranslation();
  const handleEmailSubmit = async () => {};
  return (
    <Formik
      initialValues={initialValues(mockEmailContact)}
      validationSchema={validationSchema}
      onSubmit={(values, { resetForm }) => handleEmailSubmit(values, resetForm)}
      enableReinitialize
    >
      {({ values, handleChange, handleBlur, errors, touched }) => (
        <Form>
          <PassSC>
            <Pass>
              <Heading>
                <Trans i18nKey="account/profile.string19" components={{ highlight: <Highlight /> }} />
              </Heading>
              <ChangePasswords>
                <P>{t('account/profile.string20')}</P>
                <P>{t('account/profile.string21')}</P>
                <FormDiv>
                  {edit_Email_Contact_Form.map((item) => (
                    <Grid key={item.name} container>
                      <Grid xs={12} sm={4} md={3} lg={3} xl={2}>
                        <Label>{t(item.lang)}</Label>
                      </Grid>
                      <Grid xs={12} sm={10} md={6} lg={5} xl={3}>
                        <Input
                          styling={width}
                          className="custom_inputs"
                          type={item.type}
                          name={item.name}
                          value={values[item.name]}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors[item.name]}
                          touched={touched[item.name]}
                          placeholderClass
                        />
                      </Grid>
                    </Grid>
                  ))}
                </FormDiv>
                <CustomButton type="submit" buttonStyles={{ padding: ' 9px 55px' }} isLoading={false} />
              </ChangePasswords>
            </Pass>
          </PassSC>
        </Form>
      )}
    </Formik>
  );
};
export default EditEmail;
